// TDIC - getProxiedUrl is added based on requirement
import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService } from 'gw-portals-document-js';

export default class AgentService {
    static sendServiceRequestEmailToAgent(data, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('agent'), 'sendServiceRequestEmailToAgent', [data], authHeader);
    }

    static sendUploadDocumentEmailToAgent(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('agent'), document, documentMetadata, authHeader);
    }

    static sendUploadDocumentOnClaimEmailToAgent(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('claimCenterAgent'), document, documentMetadata, authHeader);
    }
}
